import { Directive } from "@angular/core";

@Directive() // Decorator workaround for abstract class - https://github.com/angular/angular/issues/37769
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class RegisterPage {
    goToHomePage(): void {
        window.location.href = appConfig.candidHomePageUrl;
    }
}
